//pinia appState store
import { defineStore } from 'pinia';
import { Project, ProjectStore, UserInfo } from '@/types';
import updateProjectStore from '@/functions/updateProjectStore';
import StorableElementValues from '@/store/dataTransfertObject/StorableElementValues';

interface AppState {
  loaded: boolean;
  logged: boolean;
  isAccessMaster: boolean;
  user: UserInfo | null;
  loggedAt: Date | null;
  projectStores: ProjectStore[];
  currentProject: Project | null;
  projectCount: number | null;
}

export const useAppStateStore = defineStore({
  id: 'appState',
  state: (): AppState => ({
    loaded: false,
    logged: false,
    isAccessMaster: false,
    user: null,
    loggedAt: null,
    projectStores: [],
    currentProject: null,
    projectCount: null
  }),
  getters: {
    isLoaded: (state): boolean => {
      return state.loaded;
    },
    isLogged: (state): boolean => {
      return state.logged;
    },
    getIsAccessMaster: (state): boolean => {
      return state.isAccessMaster;
    },
    getUser: (state): UserInfo | null => {
      return state.user;
    },
    getLoggedAt: (state): Date | null => {
      return state.loggedAt;
    },
    getProjectStores: (state): ProjectStore[] => {
      return state.projectStores;
    },
    getCurrentProject: (state): Project | null => {
      return state.currentProject;
    },
    getProjectCount: (state): number | null => {
      return state.projectCount;
    }
  },
  actions: {
    updateLoaded(loaded: boolean) {
      this.loaded = loaded;
    },
    updateLogged(logged: boolean) {
      this.logged = logged;
    },
    updateIsAccessMaster(isAccessMaster: boolean) {
        this.isAccessMaster = isAccessMaster;
      },
    updateUser(user: UserInfo | null) {
      this.user = user;
    },
    updateLoggedAt(loggedAt: Date) {
      this.loggedAt = loggedAt;
    },
    updateProjectStore(storableElementValues: StorableElementValues) {
      updateProjectStore(this.projectStores, storableElementValues);
    },
    deleteProjectStores() {

      this.projectStores = [];
    },
    updateCurrentProject(currentProject: Project | null) {
      this.currentProject = currentProject;
    },
    deleteCurrentProject() {
      this.currentProject = null;
    },
    updateProjectCount(projectCount: number | null) {
      this.projectCount = projectCount;
    },
    deleteProjectCount() {
      this.projectCount = null;
    }
  },
  persist: true
});